import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ApplyStyles } from '@com-delta-idp/mnx-skymiles-shared';
import { ButtonModule, LinkModule } from '@com-delta-idp/mnx-ui-kit';
import {
  ButtonDirective,
  ChangeStylesDirective,
  DividerComponent,
  ExpansionPanelComponent,
  LinkDirective,
  SectionHeaderComponent
} from '@com-delta-omnichannel/aura';
import { DisplayAction, Footer } from './models/footer.interfaces';

@Component({
  selector: 'idp-footer',
  standalone: true,
  imports: [
    CommonModule,
    DividerComponent,
    ButtonModule,
    LinkModule,
    ChangeStylesDirective,
    SectionHeaderComponent,
    ButtonDirective,
    LinkDirective,
    ExpansionPanelComponent
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() content: Footer = {} as Footer;
  expanderStyle: ApplyStyles[] = [] as ApplyStyles[];
  termsConditionsStyle: ApplyStyles[] = [] as ApplyStyles[];
  expandStyle: ApplyStyles[] = [] as ApplyStyles[];
  open = false;
  isMobile = false; //CHANGE VARIABLE NAME
  ngOnInit(): void {
    this.faqQuestionsStyles();
    this.termsConditionsStyles();
  }

  faqQuestionsStyles() {
    this.expanderStyle = [
      {
        targetClass: ['aura-expansion-panel'],
        rules: {
          'background-color': '#F8F8F8',
          padding:
            window.innerWidth < 768 ? '20px 0px 20px 0px' : '15px 13px 13px 5px'
        }
      },
      {
        targetClass: ['aura-expansion-panel__body'],
        rules: {
          'background-color': '#F8F8F8',
          padding:
            window.innerWidth < 768
              ? '20px 0px 20px 0px'
              : '45px 13px 13px 5px',
          'margin-top': '2px',
          'font-size': '20px'
        }
      }
    ];
  }

  termsConditionsStyles() {
    this.termsConditionsStyle = [
      {
        targetClass: ['aura-expansion-panel'],
        rules: {
          'background-color': '#F8F8F8',
          padding:
            window.innerWidth < 768 ? '20px 0px 0px 0px' : '18px 13px 13px 0px',
          'margin-top': '2px',
          'font-family': 'Whitney-Book'
        }
      },
      {
        targetClass: ['aura-expansion-panel__body'],
        rules: {
          'font-family': 'Whitney-Book',
          'font-size': '16px',
          'background-color': '#F8F8F8',
          padding:
            window.innerWidth < 768 ? '20px 0px 0px 0px' : '18px 13px 13px 0px',
          'margin-top': '2px'
        }
      }
    ];
  }

  getActionDetail(
    open: boolean,
    actions: DisplayAction[]
  ): { id: string; label: string } {
    const actionDetail = open
      ? actions.find((action) => action.id === 'collapseAll')
      : actions.find((action) => action.id === 'expandAll');

    return { id: actionDetail?.id ?? '', label: actionDetail?.label ?? '' };
  }
}
